<template>
  <p :class="computedClass" :style="baseStyle">
    <slot />
  </p>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { sizeByScreen } from './fontUtils'

interface Props {
  className?: string
}

const props = withDefaults(defineProps<Props>(), {
  className: ''
})

// Calcul des tailles de police pour chaque breakpoint (augmentées pour une meilleure lisibilité)
// Base plus grande pour un texte de paragraphe lisible
const baseSize = sizeByScreen.mobile_s + 3 // 13 + 3 = 16px de base
const baseFontSize = `${baseSize}px`
const mobileMFontSize = `${baseSize + 1}px` // 17px
const mobileLFontSize = `${baseSize + 2}px` // 18px
const tabletFontSize = `${baseSize + 4}px` // 20px
const laptopFontSize = `${baseSize + 6}px` // 22px
const laptopLFontSize = `${baseSize + 8}px` // 24px
const screen4KFontSize = `${baseSize + 10}px` // 26px

const baseStyle = computed(() => ({
  fontSize: baseFontSize,
  lineHeight: '1.5'
}))

const computedClass = computed(() => {
  const classes = ['font-inter']
  if (props.className) {
    classes.push(props.className)
  }
  return classes.join(' ')
})
</script>

<style scoped>
p {
  font-size: v-bind('baseFontSize');
  line-height: 1.5;
}

@media (min-width: 375px) {
  p {
    font-size: v-bind('mobileMFontSize');
  }
}

@media (min-width: 425px) {
  p {
    font-size: v-bind('mobileLFontSize');
  }
}

@media (min-width: 768px) {
  p {
    font-size: v-bind('tabletFontSize');
  }
}

@media (min-width: 1024px) {
  p {
    font-size: v-bind('laptopFontSize');
  }
}

@media (min-width: 1440px) {
  p {
    font-size: v-bind('laptopLFontSize');
  }
}

@media (min-width: 2560px) {
  p {
    font-size: v-bind('screen4KFontSize');
  }
}
</style>
